import _ from 'underscore';

import {LegacyRunQueryOutput} from 'insights/warehouse/AnalyticsWarehouseTypes';
import getWarningMessageForRowLimit from 'insights/warehouse/getWarningMessageForRowLimit';

/**
 * Generate warning messages for block's visualizations
 *
 * Examples: # rows too high, # chips too high
 */
export default function getVisualizationWarnings(
  runQueryOutput: LegacyRunQueryOutput,
  isDisplayingSubQueryResults: boolean = false
): Array<string> {
  return _.compact([
    getWarningMessageForRowLimit(runQueryOutput),
    isDisplayingSubQueryResults
      ? 'Displayed results are from a sub query and will not be saved on dashboard.'
      : null,
  ]);
}
